import React, { useEffect, useState } from "react";
import { Card, Col, Form, Row , Container} from "react-bootstrap";
import SmuBadge from "../../utils/smu-badge/SmuBadge";
import SmuLoading from "../../utils/smu-loading/SmuLoading";
import { createReport } from "../../api/reports";
import { toast } from "../../helpers/smu-alerts/smu-lerts";
import { registerLocale } from  "react-datepicker";
import { es } from 'date-fns/locale/es';

import { IconCalendar2 } from "../../icons/Icon"
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

import moment from "moment";

registerLocale('es', es)

const LoadCatalogs = () => {
    const [type, setType] = useState("");
    const [startDate, setStartDate] = useState(moment().format("MM-DD-YYYY"));
    const [endDate, setEndDate] = useState(moment().format("MM-DD-YYYY"));
    const [showLoading, setShowLoading] = useState(false);
    const exportData = (data, fileName, type) => {
        // Create a link and download the file
        const blob = new Blob([data], { type });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = fileName;
        a.click();
        window.URL.revokeObjectURL(url);
      };

    const csvParse = (json, separator=',') => {
        const items = json.data
        const replacer = (key, value) => value === null ? '' : value // specify how you want to handle null values here
        const header = Object.keys(items[0])
        const csv = [
        header.join(separator), // header row first
        ...items.map(row => header.map(fieldName => JSON.stringify(row[fieldName], replacer)).join(separator))
        ].join('\r\n')
        return csv
    }

    const generateReport = () => {
        setShowLoading(true);
        const data = {type: type, start_date: moment(startDate).format("MM-DD-YYYY"), end_date: moment(endDate).format("MM-DD-YYYY")}
        createReport(data).then((response) => {

            if(response.data.data.length == 0) {
                toast({ icon: "success", title: "No hay datos en la fecha seleccionada" });
                return false;
            }

            const csv = csvParse(response.data, "|")
            const  fileDate = moment().format('DD-MM-YYYY HH:mm:ss')
            const fileName = type == 'Login' ? `Reporte ${type} ${fileDate}.csv` : `Reporte ${type} ${fileDate}.csv`;
            exportData(csv, fileName, 'text/csv;charset=utf-8;');
            setShowLoading(false);
            toast({ icon: "success", title: "Reporte creado." });
        }).catch((error) => {
            toast({ icon: "error", title: "Error al generar reporte" });
            setShowLoading(false);
        })
    }

  return (
    <Card className="smu-card">
      <Card.Header className="d-flex flex-column py-4">
        <div className="d-flex align-items-center me-auto">
          <SmuBadge color="#CABDFF" />
          <span className="fs-5 ms-3 me-auto">Generar Reporte</span>
        </div>
      </Card.Header>
      <Card.Body className="d-flex flex-column px-5">
        <Form
          className="smu-form pb-5"
        >
            <Container>

                <Row className="d-flex text-center mb-5">
                    <Col>
                        <Form.Label>Fecha Inicio</Form.Label>
                        <DatePicker
                            selected={startDate}
                            onChange={(date) => setStartDate(new Date(moment(date || new Date()).format("MM-DD-YYYY")))}
                            dateFormat="dd/MM/yyyy"
                            selectsStart
                            startDate={startDate}
                            endDate={endDate}
                            locale="es"
                            showIcon
                            icon={
                                <span style={{ filter: "grayscale(1)", right: "5px", top: "-3px" }}>
                                  <IconCalendar2 aria-label="Calendario" />
                                </span>
                              }
                            maxDate={moment().add(100, 'years').toDate()}
                        />
                    </Col>
                    <Col>
                        <Form.Label>Fecha Termino</Form.Label>
                            <DatePicker
                                selected={endDate}
                                onChange={(date) => setEndDate(new Date(moment(date || new Date()).format("MM-DD-YYYY")))}
                                selectsEnd
                                dateFormat="dd/MM/yyyy"
                                startDate={startDate}
                                endDate={endDate}
                                minDate={startDate}
                                locale="es"
                                showIcon
                                icon={
                                  <span style={{ filter: "grayscale(1)", right: "5px", top: "-3px" }}>
                                    <IconCalendar2 aria-label="Calendario" />
                                  </span>
                                }
                                maxDate={moment().add(100, 'years').toDate()}
                            />
                    </Col>
                </Row>

            <Row className="d-flex text-center">
                <Col sm={8}>
                    
                    <Form.Select aria-label="Default select example" 
                    onChange={(e) => setType(e.currentTarget.value)}
                    >
                        <option>Seleccione una opcion</option>
                        <option value="Login">Conexiones</option>
                        <option value="Downloads">Visualizaciones faldones</option>
                        <option value="Changes">Actualizaciones faldones</option>
                    </Form.Select>
                
                </Col>
                <Col sm={4}>
                    <button
                        type="button"
                        onClick={generateReport}
                        className="btn smu-generic-button text-truncate px-3 h-100"
                    >
                        Generar
                    </button>
                    
                
                </Col>
            </Row>
                <br></br>
            <Row className="d-flex text-center mt-10">
                <Col sm={4}>
                    &nbsp;
                </Col>
                <Col sm={4}>
                    { 
                        showLoading && <SmuLoading label="Generando reporte..."  /> }
                </Col>
                <Col sm={4}>
                    &nbsp;
                </Col>
            </Row>
            </Container>
        </Form>

      </Card.Body>
    </Card>
  );
};

export default LoadCatalogs;
